import { useState } from 'react';
import { select, t } from '@lingui/core/macro';
import { Box, Chip, TeamAvatar, Tooltip, UserAvatar } from '@pocketlaw/tetris';
export function AccessManagementSearchItem(props) {
    const { type, name, subtitle, disabled } = props;
    const [hover, setHover] = useState(false);
    const Avatar = type === 'team' ? TeamAvatar : UserAvatar;
    const tooltip = select(type, {
        user: 'This user has access from a parent folder. You can not modify it here.',
        team: 'This team has access from a parent folder. You can not modify it here.',
        other: 'This user/team has access from a parent folder. You can not modify it here.',
    });
    return (<Box alignItems="center" gap="md" justifyContent="space-between" width="100%" onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <Avatar title={name} subtitle={subtitle} size="sm"/>
      {disabled && hover && (<Tooltip title={tooltip}>
          <Chip size="small" appearance="secondary" label={t({ message: 'Inherited access', comment: 'Access management - Inherited label' })}/>
        </Tooltip>)}
    </Box>);
}
